import styled from "@emotion/styled";
import React from "react";
import { GREEN_500, RED_500, YELLOW_500 } from "../../common/styles/colors";
import { P } from "../../common/styles/typography";

const getBatteryPercentColor = (batteryPercent: number) => {
    if (batteryPercent <= 30) {
        return RED_500;
    }
    if (batteryPercent <= 65) {
        return YELLOW_500;
    }
    return GREEN_500;
};

type BatteryPercentage = {
  batteryPercentage: number;
};

const StyledBatteryPercentageContainer = styled.div`
    position: relative;
`;

const StyledBatteryPercentage = styled.svg`
    height: 100%;
    width: 100%;
`;

const StyledBatteryPercentagePath = styled.path`
  fill: ${(props: BatteryPercentage) => getBatteryPercentColor(props.batteryPercentage)};
  transform: scaleX(
      ${(props) => Math.min(props.batteryPercentage, 100) / 100}
    );
  transform-origin: 0% 50%;
  transform-box: fill-box;
`;

const StyledBatteryPercentageText = styled(P)`
    position: absolute;
    top: 50%;
    left: 50%;
    font-weight: bold;
    transform: translate(-50%, -50%);
`;

export default ({
    batteryPercentage,
    className,
}: {
  batteryPercentage: number;
  className?: string;
}) => (
    <StyledBatteryPercentageContainer className={className}>
        <StyledBatteryPercentage
            viewBox="0 0 29 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.789474 2.40917C0.789474 1.22396 1.66966 0.263153 2.75543 0.263153H24.8725C25.9582 0.263153 26.8384 1.22396 26.8384 2.40917V8.31073C26.8384 9.49594 25.9582 10.4567 24.8725 10.4567H2.75543C1.66966 10.4567 0.789474 9.49594 0.789474 8.31073V2.40917Z"
                fill="black"
            />
            <path
                d="M3.73808 4.55526C3.73808 3.37005 4.61827 2.40924 5.70403 2.40924H26.3466C27.4324 2.40924 28.3126 3.37005 28.3126 4.55526V6.16477C28.3126 7.34999 27.4324 8.31079 26.3466 8.31079H5.70404C4.61827 8.31079 3.73808 7.34999 3.73808 6.16477V4.55526Z"
                fill="black"
            />
            <path
                d="M1.77261 2.94582C1.77261 2.05691 2.43276 1.3363 3.24708 1.3363H24.3811C25.1955 1.3363 25.8556 2.05691 25.8556 2.94582V7.77436C25.8556 8.66327 25.1955 9.38388 24.3811 9.38388H3.24708C2.43276 9.38388 1.77261 8.66327 1.77261 7.77436V2.94582Z"
                fill="white"
            />
            <StyledBatteryPercentagePath
                d="M1.77261 2.94582C1.77261 2.05691 2.43276 1.3363 3.24708 1.3363H24.3811C25.1955 1.3363 25.8556 2.05691 25.8556 2.94582V7.77436C25.8556 8.66327 25.1955 9.38388 24.3811 9.38388H3.24708C2.43276 9.38388 1.77261 8.66327 1.77261 7.77436V2.94582Z"
                batteryPercentage={batteryPercentage}
            />
        </StyledBatteryPercentage>
        <StyledBatteryPercentageText>
            {`${Number.isInteger(batteryPercentage) && batteryPercentage >= 0 ? batteryPercentage : "?"}%`}
        </StyledBatteryPercentageText>
    </StyledBatteryPercentageContainer>
);
